function appendDiamondGrading(container, diamond) {
  const grades = { ID: 'Ideal', EX: 'Excellent', VG: 'Very Good', G: 'Good', F: 'Fair', P: 'Poor' };
  const fluorescence = { N: 'None', F: 'Faint', VSL: 'Very Slight', M: 'Medium', SL: 'Slight', NONE: 'None', FAINT: 'Faint', 'VERY SLIGHT': 'Very Slight', MEDIUM: 'Medium', SLIGHT: 'Slight' };
  const isRound = /^round(?:\s+cut)?$/i.test(String(diamond.shape || '').trim());
  const fields = [
    ['Measurement', diamond.measurements],
    ['Cut', isRound ? grades[diamond.cut_precision] : ''],
    ['Polish', grades[diamond.polish] || diamond.polish],
    ['Symmetry', grades[diamond.symmetry] || diamond.symmetry],
    ['Fluorescence', fluorescence[String(diamond.fluorescent || '').trim().toUpperCase()]]
  ];
  container.classList.add('lucce-selector-grading');
  fields.forEach(function (field) {
    if (!field[1] || field[1] === 'null' || field[1] === 'undefined') return;
    const row = document.createElement('div');
    row.className = 'lucce-selector-grading__row';
    const label = document.createElement('span');
    const value = document.createElement('span');
    label.textContent = field[0] + ':';
    value.textContent = field[1];
    row.append(label, value);
    container.appendChild(row);
  });
}

// This file handles the network requests to the lucce api for retrieving the list of diamonds and their details.
// The request for retrieving diamonds come in groups of 20, designate by a page parameter in the get request url.
// The filter information is also included in the request url.
//
// Once the network request for the diamond batch is recieved.  A createDiamonds() func creates html elements per diamond.
//
// When a diamond is selected, another network request is made to the lucce api to trigger the creation of a diamond in the shopify store.

//update
//Lucce API server
let web_server = 'https://api.luccerings.com'
// web_server = 'http://127.0.0.1:8022'

let wide_screen_min_width = 1296

//if mobile show filter screen
if(window.innerWidth <= 750){
  document.getElementById('Customize-Filter-Open').click()
}


//Variables
let diamond_key 
let mobile_g
let mobile_f
let page = 1
let next_page = true
let diamond_pagination_ready = false
let diamond_request_version = 0
let diamond_shape = url.searchParams.get('shape').slice(0,-4).toUpperCase()
let all_cut = false
let filter
let sort = 'carat-low'
let first_load = true
let prev_sort
let ids = ''
let exclude = ''
let is_earring = url.searchParams.get('earrings')
let diamond_load_retries = 0
let diamond_load_retry_timeout
let diamond_load_retry_in_progress = false

function formatDiamondSelectorMoney(price) {
  return '<span data-lucce-convert data-lucce-php-price="' + Number(price) + '">\u20b1' + Number(price).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '</span>';
}

function refreshDiamondSelectorCurrency() {
  [100, 500, 1200].forEach(delay => {
    window.setTimeout(() => {
      if (window.LucceCurrencyFormatter && typeof window.LucceCurrencyFormatter.refresh === 'function') {
        window.LucceCurrencyFormatter.refresh();
      }

      if (!window.bucksCC) return;

      if (typeof window.bucksCC.convert === 'function') window.bucksCC.convert();
      if (typeof window.bucksCC.convertAll === 'function') window.bucksCC.convertAll();
      if (typeof window.bucksCC.refresh === 'function') window.bucksCC.refresh();
      if (typeof window.bucksCC.update === 'function') window.bucksCC.update();
    }, delay);
  });
}


if(diamond_shape == 'ALL'){
  all_cut = true
  filter = '&SHAPE=ROUND'
  diamond_shape = 'ROUND'
  diamond_type = '0'
} else {
  filter = '&SHAPE=' + diamond_shape 
}

if(is_earring == 'true' || is_necklace){
  filter = filter + '&CTS_MIN=.25'
}

if(diamond_type == '1'){
  filter = filter + '&NATURAL=1' + '&CERT=GIA' + '&COLOR_MIN=I' + '&CLARITY_MIN=VS2' + '&CUT_MIN=VG' + '&PRICE_PHP_MAX=25000000'
  //remove Certificate Selection //GIA only
  document.getElementById('Customize-Certificate-Filter-Section').style.display = 'none'
  document.getElementById('Filter-Certificate-Btn-IGI-Small-Screen').style.visibility = 'hidden'

  filter_igi_btn.classList.remove('filter-certificate-btn-active')
  filter_igi_btn_small.classList.remove('filter-certificate-btn-active')
  filter_gia_btn.classList.add('filter-certificate-btn-active')
  filter_gia_btn_small.classList.add('filter-certificate-btn-active')


}

//filter on load
let filter_prev = {
  'CTS_MIN':filter_values_default['CTS_MIN']/100,
  'CTS_MAX':filter_values_default['CTS_MAX']/100,
  'COLOR_MIN':filter_values_default['COLOR_MIN'],
  'COLOR_MAX':filter_values_default['COLOR_MAX'],
  'CLARTIY_MIN':filter_values_default['CLARITY_MIN'],
  'CLARITY_MAX':filter_values_default['CLARITY_MAX'],
  'CUT_MIN':filter_values_default['CUT_MIN'],
  'CUT_MAX':filter_values_default['CUT_MAX'],
  'PRICE_PHP_MIN':filter_values_default['PRICE_PHP_MIN'],
  'PRICE_PHP_MAX':filter_values_default['PRICE_PHP_MAX'],
}

let color_scale_static = {
    'J':329,
    'I':431,
    'H':537,
    'G':650,
    'F':760,
    'E':869,
    'D':1000,
  }

let clarity_scale_static = {
    'SI2':29,
    'SI1':184,
    'VS2':313,
    'VS1':444,
    'VVS2':586,
    'VVS1':735,
    'IF':863,
    'FL':1000,
  }

let color_keys = Object.keys(color_scale_static)
let clarity_keys = Object.keys(clarity_scale_static)

let precision_conversion = {
  'ID':'Ideal',
  'EX':'Excellent',
  'VG':'Very Good',
  'G': 'Good',
  'F': 'Fair',
  'U': 'Unknown'
}

  
//filter event
document.getElementById('Customize-Filter-Container').addEventListener('change',filterDiamondChange)

//sort event
document.getElementById('Customize-Diamond-Sort').addEventListener('change',filterDiamondChange)
  
loadDiamondKey()

//inital diamond load
//loadNextDiamondPage(page,filter,exclude)


//diamond key
function loadDiamondKey(){
  showDiamondLoadingSpinner()
  fetch(web_server +'/diamond_key')
  .then(resp=>resp.json())
  .then(json=>{
    diamond_key = json
    loadNextDiamondPage(page,filter,exclude,false)
  })
  .catch(err=>{
    //try reloading Diamond Page
    if(diamond_load_retries < 3){
      console.log('retrying attempt:' + (diamond_load_retries + 1))
      diamond_load_retry_in_progress = true
      diamond_load_retries = diamond_load_retries + 1
      diamond_load_retry_timeout = setTimeout(()=>{
        loadNextDiamondPage(page,filter,exclude,true)
        diamond_load_retry_in_progress = false
       },1000) 
    } else{
      removeDIamondLoadingSpinner()
      showMessage('Error loading diamonds. Please contact support.')
    }
  })
}


//main function
function loadNextDiamondPage(page,filter,exclude,retry){
  if(retry == false && diamond_load_retry_in_progress){
    clearTimeout(diamond_load_retry_timeout)
  }
  //if there is a next_page of diamonds, load it
  //exclude is no longer used
  if(next_page){
    const request_version = ++diamond_request_version
    diamond_pagination_ready = false
    document.removeEventListener('scroll', loadNext)
    //get start time
    let start = new Date()

    removeMessage()
    showDiamondLoadingSpinner()
    showFilterLoadingSpinner()

    fetch(web_server +'/diamonds?page='+page+filter)
    .then(resp=>resp.json())
    .then(json=>request_version === diamond_request_version ? parseDiamonds(json) : undefined)
    .then(diamonds=>request_version === diamond_request_version ? createDiamonds(diamonds) : undefined)
    .then(diamond_len=>{
      if (request_version !== diamond_request_version) return
      //get end time
      //time_out ensures load time is a minimum of 1 sec
      let time_out = getLoadingTimeOut(start)
      removeDIamondLoadingSpinner(time_out)
      removeFilterLoadingSpinner(time_out)

      //delay if needed
      return new Promise((resolve) => {
        setTimeout(() => resolve(diamond_len), time_out);
      });
    })
    .then(diamond_len=>{
      if (request_version !== diamond_request_version) return
      setWrapperLength(diamond_len)
      showNewDiamondListings()


      if(diamond_len == 0){
        showMessage('No Results')
      }

      //inc page 
      getLastDiamondRow()

      //if succeeded, set retries to 0
      diamond_load_retries = 0
    })
    .catch(err=>{
      if (request_version !== diamond_request_version) return
      console.log(err)
      //get end time
      //time_out ensures load time is a minimum of 1 sec

      if(diamond_load_retries < 3){
        diamond_load_retry_in_progress = true
        //console.log('retrying attempt:' + (diamond_load_retries + 1))
        diamond_load_retries = diamond_load_retries + 1
        diamond_load_retry_timeout = setTimeout(()=>{
         if (request_version !== diamond_request_version) return
         loadNextDiamondPage(page,filter,exclude,true)
         diamond_load_retry_in_progress = false
        },1000) 
      } else {
        let time_out = getLoadingTimeOut(start)
        removeDIamondLoadingSpinner(time_out)
        removeFilterLoadingSpinner(time_out)

        setTimeout(()=>{if (request_version === diamond_request_version) showMessage('Error loading diamonds. Please contact support.')},time_out)
      }
    })
  }
}







//List of all other Funcs

function parseDiamonds(json){

    let diamonds = json['diamonds']
    let diamonds_list = []
    next_page = json['next_page']
    for(let x=0;x<diamonds.length;x++){
        let certifcate_logo_link
        if(diamond_key['certs'][String(diamonds[x]['certificate'])] == 'IGI'){
          certifcate_logo_link = 'https://cdn.shopify.com/s/files/1/0023/2878/9049/files/logo_IGI.png'
        } else {
          certifcate_logo_link = 'https://cdn.shopify.com/s/files/1/0023/2878/9049/files/gia-logo.png'
        }

        diamonds_list.push({
            'id':diamonds[x]['id'],
            'shape':diamond_key['shapes'][String(diamonds[x]['shape'])],
            'cts':diamonds[x]['cts'],
            'color':diamond_key['colors'][String(diamonds[x]['color'])],
            'clarity':diamond_key['clarities'][String(diamonds[x]['clarity'])],
            'cut_precision':diamond_key['cuts'][String(diamonds[x]['cut_precision'])],
            'fluorescent': (diamond_key['fluorescents'] || {})[String(diamonds[x]['fluorescent'])] || diamonds[x]['fluorescent'] || '',
            'certificate': diamond_key['certs'][String(diamonds[x]['certificate'])],
            'certificate_logo':certifcate_logo_link,
            'certificate_link':diamonds[x]['certificate_link'],
            'certificate_number':diamonds[x]['certificate_number'],
            'measurements':diamonds[x]['measurements'],
            'video':diamonds[x]['video'],
            'polish': diamond_key['polishes'][String(diamonds[x]['polish'])], //diamonds[x]['polish'],
            'symmetry':diamond_key['symms'][String(diamonds[x]['symmetry'])], //diamonds[x]['symmetry'],
            'price':diamonds[x]['price_php'],
            'img':diamonds[x]['img'],
            's3_img':diamonds[x]['s3_img'],
            'use_s3':json['use_s3'],

        })
    }
  
    return diamonds_list
}


function filterDiamondChange(){
//called on filter/sort change
//get values
sort = document.getElementById('Customize-Diamond-Sort').value
let carat_values = $( "#Slider-Range-Carat" ).slider('option','values')
let color_values = $( "#Slider-Range-Color" ).slider('option','values')
let clarity_values = $( "#Slider-Range-Clarity" ).slider('option','values')
let cut_values = $( "#Slider-Range-Cut" ).slider('option','values')
let price_values = $( "#Slider-Range-Price" ).slider('option','values')

let cert
if(diamond_type == '1'){
  cert = 'GIA'
}
else if(document.getElementById('Filter-Certificate-Btn-IGI').classList.contains('filter-certificate-btn-active') ||
document.getElementById('Filter-Certificate-Btn-IGI-Small-Screen').classList.contains('filter-certificate-btn-active')){
  cert = 'IGI'
} else {
  cert = 'GIA'
}


let fv = {
  'SHAPE':diamond_shape,
  'CTS_MIN':carat_values[0]/100,
  'CTS_MAX':carat_values[1]/100,
  'COLOR_MIN':color_values[0],
  'COLOR_MAX':color_values[1],
  'CLARTIY_MIN':clarity_values[0],
  'CLARITY_MAX':clarity_values[1],
  'CUT_MIN':cut_values[0],
  'CUT_MAX':cut_values[1],
  'PRICE_PHP_MIN':price_values[0],
  'PRICE_PHP_MAX':price_values[1],
  'CERT': cert,
  'NATURAL':diamond_type
}

//if filter didn't change from previous change event, just return
if(JSON.stringify(fv) === JSON.stringify(filter_prev) && sort == prev_sort){
  return
}

//if not earring, cts_min cannot go below .5
if(is_earring != 'true' && is_necklace == false){
  if(fv['CTS_MIN'] < 0.5){
    fv['CTS_MIN'] = 0.5
  }
}

//url parameters
filter = '&SHAPE='+ diamond_shape +'&CTS_MIN=' + fv['CTS_MIN'] + 
         '&CTS_MAX=' + fv['CTS_MAX'] + 
         '&COLOR_MIN=' + color_index[fv['COLOR_MIN']] +
         '&COLOR_MAX=' + color_index[fv['COLOR_MAX']] +
         '&CLARITY_MIN=' + clarity_index[fv['CLARTIY_MIN']] +
         '&CLARITY_MAX=' + clarity_index[fv['CLARITY_MAX']] +
         '&CUT_MIN=' + cut_index[fv['CUT_MIN']] +
         '&CUT_MAX=' + cut_index[fv['CUT_MAX']] +
         '&PRICE_PHP_MIN=' + fv['PRICE_PHP_MIN'] +
         '&PRICE_PHP_MAX=' + fv['PRICE_PHP_MAX'] +
         '&SORT=' + sort + '&CERT=' + cert + '&NATURAL=' + diamond_type

exclude = ''

clearDiamondList()
page=1
loadNextDiamondPage(page,filter,exclude,false)
window.scrollTo(0, 0);


prev_sort = sort
filter_prev = {
  'SHAPE':diamond_shape,
  'CTS_MIN':carat_values[0]/100,
  'CTS_MAX':carat_values[1]/100,
  'COLOR_MIN':color_values[0],
  'COLOR_MAX':color_values[1],
  'CLARTIY_MIN':clarity_values[0],
  'CLARITY_MAX':clarity_values[1],
  'CUT_MIN':cut_values[0],
  'CUT_MAX':cut_values[1],
  'PRICE_PHP_MIN':price_values[0],
  'PRICE_PHP_MAX':price_values[1],
  'CERT':cert,
  'NATURAL':diamond_type
  }

}



function clearDiamondList(){
  diamond_request_version++
  clearTimeout(diamond_load_retry_timeout)
  diamond_load_retry_in_progress = false
  diamond_load_retries = 0
  next_page = true
  diamond_pagination_ready = false
  //remove previous scroll eventlistener
  document.removeEventListener("scroll",loadNext)

  let diamonds = Array.from(document.querySelectorAll('.diamond-list-row'))
  let diamond_wrappers = Array.from(document.querySelectorAll('.diamond-detailed-view-wrapper'))

  for(let x=diamonds.length-1; x>=0;x--){
    diamonds[x].remove()
  }

  for(let x=diamond_wrappers.length-1; x>=0;x--){
    diamond_wrappers[x].remove()
  }
}

function getLastDiamondRow(){
  page = page + 1
  diamond_pagination_ready = Boolean(next_page)
  if (diamond_pagination_ready) {
    document.addEventListener('scroll', loadNext, { passive: true })
    requestAnimationFrame(loadNext)
  }
  first_load = false
}

window.addEventListener('resize', loadNext, { passive: true })

function loadNext(){
  //if scroll event is near last row
  //load next diamond page and remove listener

  if (!diamond_pagination_ready || !next_page) return
  let last_row = Array.from(document.querySelectorAll('.diamond-list-row'))
  last_row = last_row[last_row.length-1]
  if(last_row){
    if(last_row.getBoundingClientRect().bottom - window.innerHeight <= 300){
      diamond_pagination_ready = false
      document.removeEventListener('scroll', loadNext)
      exclude = '&EXCLUDE=' + ids
      loadNextDiamondPage(page,filter,exclude,false)
    }
  }
}



function showDiamondLoadingSpinner(){
  if(page > 1){
      let diamond_container =  document.getElementById('Diamond-List-Container')
      diamond_container.style.opacity = '0.5'
      let diamond_container_client = diamond_container.getBoundingClientRect()
      var style = diamond_container.currentStyle || window.getComputedStyle(diamond_container);

      let spinner_x_pos = diamond_container_client.left + diamond_container_client.width/2 - 20
      let spinner_y_pos = diamond_container_client.height + parseInt(style.marginTop) + new_nav_total

      let ctc = document.getElementById('Customize-Loader-Container')

      ctc.style.left = spinner_x_pos + 'px'
      ctc.style.top = spinner_y_pos + 'px'
      ctc.style.visibility = 'visible'
  } else {
    ids = ''

    let column_headers =  document.getElementById('Customize-Column-Headers')
    let column_headers_client = column_headers.getBoundingClientRect()
    let diamond_container =  document.getElementById('Diamond-List-Container')
    let diamond_container_client = diamond_container.getBoundingClientRect()
    var style = diamond_container.currentStyle || window.getComputedStyle(diamond_container);

    let spinner_x_pos = column_headers_client.left + column_headers_client.width/2 - 20
    let spinner_y_pos = diamond_container_client.height + parseInt(style.marginTop) + new_nav_total

    let ctc = document.getElementById('Customize-Loader-Container')

    ctc.style.left = spinner_x_pos + 'px'
    ctc.style.top = spinner_y_pos + 'px'
    ctc.style.visibility = 'visible'
  }
}

function removeDIamondLoadingSpinner(time_out){

    let diamond_container =  document.getElementById('Diamond-List-Container')
    diamond_container.style.opacity = '1'
    let ctc = document.getElementById('Customize-Loader-Container')

   setTimeout(()=>{
    ctc.style.visibility = 'hidden'
   },time_out)    
}


function showFilterLoadingSpinner(){
  if(window.innerWidth < wide_screen_min_width){
    let diamond_container =  document.getElementById('Filter-Customize-Loader-Container')
    diamond_container.style.visibility = 'visible'
    let filter_msg = document.getElementById('Filter-Customize-Loader-Msg')
    filter_msg.innerText = 'loading...'
    filter_msg.style.display = 'block'
  }
}

function removeFilterLoadingSpinner(time_out){
  let diamond_container =  document.getElementById('Filter-Customize-Loader-Container')
  let see_results = document.getElementById('Filter-Customize-Loader-Results')
  see_results.classList.remove('customize-text-shadow-fade')
  setTimeout(()=>{
    diamond_container.style.visibility = 'hidden'
    let filter_msg = document.getElementById('Filter-Customize-Loader-Msg')
    filter_msg.innerText = 'done'
    see_results.classList.add('customize-text-shadow-fade')
    setTimeout(()=>{
      filter_msg.style.display='none';
  },300)
  },time_out)

}

function showMessage(msg){
  let retry_btn = false
  let retry_span
  if(msg == 'Error loading diamonds. Please contact support.'){
    retry_span = document.createElement('span')
    retry_span.style.paddingLeft = '7px'
    retry_span.style.cursor = 'pointer'
    retry_span.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" style="position:absolute;margin-top:2px;" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
    </svg>`

    retry_span.addEventListener('click',()=>{
      loadNextDiamondPage(page,filter,exclude,false)
    })
    retry_btn = true
  }

  let message = document.getElementById('Customize-Message')
  message.innerText = msg

  let msg_width = window.innerWidth * .5


  if(page > 1){
    let diamond_container =  document.getElementById('Diamond-List-Container')
    let diamond_container_client = diamond_container.getBoundingClientRect()
    var style = diamond_container.currentStyle || window.getComputedStyle(diamond_container);

    let msg_x_pos = diamond_container_client.left + diamond_container_client.width/2 - (msg_width/2) 
    let msg_y_pos = diamond_container_client.height + parseInt(style.marginTop) + 24 + new_nav_total

    let error_msg_container = document.getElementById('Customize-Message-Container')

    error_msg_container.style.left = msg_x_pos + 'px'
    error_msg_container.style.top = msg_y_pos + 'px'
    error_msg_container.style.display = 'block'

    if(retry_btn){
      message.append(retry_span)
    }
} else {

  let column_headers =  document.getElementById('Customize-Column-Headers')
  let column_headers_client = column_headers.getBoundingClientRect()
  let diamond_container =  document.getElementById('Diamond-List-Container')
  let diamond_container_client = diamond_container.getBoundingClientRect()
  var style = diamond_container.currentStyle || window.getComputedStyle(diamond_container);
  
  // console.log('column headers left', column_headers_client.left)
  // console.log('column headers half', (column_headers_client.width/2))
  // console.log('msg width half',(msg_width/2))

  let msg_x_pos = column_headers_client.left + (column_headers_client.width/2) - (msg_width/2)
  let msg_y_pos = diamond_container_client.height + parseInt(style.marginTop) + 24 + new_nav_total

  let error_msg_container = document.getElementById('Customize-Message-Container')

  error_msg_container.style.left = msg_x_pos + 'px'
  error_msg_container.style.top = msg_y_pos + 'px'
  error_msg_container.style.display = 'block'

  if(retry_btn){
    message.append(retry_span)
  }
}
}

function removeMessage(){
  let error_msg_container = document.getElementById('Customize-Message-Container')
  error_msg_container.style.display = 'none'
}

function setWrapperLength(len){
  if(page == 1 && first_load == false){
    //set wrapper back to initial height //additional 125 is added so error messages are shown and buffer
    let height = diamond_list_top + (72*len) + 125 + 'px'
    wrapper.style.height = height
    main_content.style.height = height
  } else {
    let height = wrapper.getBoundingClientRect().height + (72*len) + 'px'
    wrapper.style.height = height
    main_content.style.height = height
  }
}



function createDiamonds(diamonds){
  for(let i=0;i<diamonds.length;i++){
    let grey
    i % 2 == 0 ? grey = true : grey = false
    createDiamondListing(diamonds[i],grey)
    addDiamondEventListners(diamonds[i])
  }

  refreshDiamondSelectorCurrency()
  return diamonds.length
}

function showNewDiamondListings(){
  let new_listings = Array.from(document.querySelectorAll('.diamond-list-new'))

  new_listings.forEach(row=>{
    row.style.display = 'flex'
    row.classList.remove('diamond-list-new')
  })

  refreshDiamondSelectorCurrency()
}


function createDiamondListing(diamond,grey){

    ids = ids + diamond['id'] + ','

    //1. CREATE ROW
    let row = document.createElement('div')
    row.style.display = 'none'
    row.id = 'Diamond-List-Row-' + diamond['id']
    row.classList.add('diamond-list-row')
    row.classList.add('diamond-list-new')
    row.addEventListener('click',(e)=>{rowListenerOpenCloseDiamondDetails(e,diamond['color'],diamond['clarity'],diamond['id'])})
    if(grey)
    row.classList.add('diamond-row-grey')



    //2. CREATE ROW ITEMS

    //a. diamond img
    let img_small_container = document.createElement('div')
    img_small_container.classList.add('diamond-list-item')
    img_small_container.classList.add('diamond-img')
    img_small_container.classList.add('customize-desktop')

    let img_small_wrapper = document.createElement('div')
    img_small_wrapper.classList.add("customize-crop-center-wrapper")
    
    let img_small = document.createElement('img')
    if(diamond['use_s3']){
      img_small.src = 'https://lucce-storage.s3.ap-east-1.amazonaws.com/media/thumbnails/thumb-' + diamond['s3_img'] + '.jpg'
    } else {
      img_small.src = diamond['img']
    }
    
    img_small.height = 50
    img_small_backup = `data:image/jpeg;base64,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`
    img_small.addEventListener('error',(e)=>{
      e.target.src = img_small_backup
    })

    img_small_wrapper.append(img_small)
    img_small_container.append(img_small_wrapper)

    //b. cts
    let cts = document.createElement('div')
    cts.classList.add('diamond-list-item')
    cts.classList.add('diamond-cts')
    cts.innerText = diamond['cts'] + 'ct'

    //c. color
    let color = document.createElement('div')
    color.classList.add('diamond-list-item')
    color.classList.add('diamond-color')
    color.innerText = diamond['color']


    //d. clarity
    let clarity = document.createElement('div')
    clarity.classList.add('diamond-list-item')
    clarity.classList.add('diamond-clarity')
    clarity.innerText = diamond['clarity']


    //e. precision
    let precision = document.createElement('div')
    precision.classList.add('diamond-list-item')
    precision.classList.add('diamond-precision')
    
    if(diamond_shape == 'ROUND'){
      precision.innerText = diamond['cut_precision']
    } else {
      precision.innerText = diamond['symmetry']
    }
 

    //f. certificate
    let certificate = document.createElement('div')
    certificate.classList.add('diamond-list-item')
    certificate.classList.add('diamond-certificate')
    

    let c_img = document.createElement('img')
    c_img.src = diamond['certificate_logo']
    
    let c_span = document.createElement('span')
    c_span.innerText = diamond['certificate']
    c_span.style.opacity = '0'

    let c_link = document.createElement('a')
    if(diamond['certificate'] == 'IGI'){
      c_link.href = 'https://www.igi.org/verify-your-report/?r=' + diamond['certificate_number'] 
    } else {
      c_link.href = diamond['certificate_link']
    }
    c_link.target = '_blank'
    c_link.classList.add('diamond-certificate-link')

    //any click on certificate opens certiifcate link
    certificate.addEventListener('click',(e)=>{
      e.stopPropagation()
      let link = e.target.parentElement.querySelector('.diamond-certificate-link')
      if(link !== null){
        link.click()
      }
    })
    
    c_link.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="13" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/></svg>`
    
    
  //   `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  //   width="13" height="13" viewBox="0 0 512.000000 512.000000"
  //   preserveAspectRatio="xMidYMid meet">
   
  //  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  //  fill="#adadad" stroke="none">
  //  <path d="M1053 5095 c-152 -41 -298 -173 -347 -313 l-15 -42 1642 0 c1020 0
  //  1668 -4 1710 -10 265 -39 492 -205 607 -444 81 -170 74 6 77 -1904 l3 -1703
  //  23 6 c115 33 247 142 305 251 66 127 63 7 60 1981 l-3 1788 -22 60 c-46 119
  //  -139 229 -243 284 -121 65 4 61 -1960 60 -1503 0 -1793 -3 -1837 -14z"/>
  //  <path d="M438 4450 c-166 -28 -299 -123 -376 -268 -66 -124 -63 -7 -60 -1979
  //  l3 -1788 22 -60 c46 -119 139 -229 243 -284 121 -65 -3 -61 1955 -61 1941 0
  //  1830 -3 1947 56 62 32 156 119 198 184 16 25 40 73 52 106 l23 59 3 1788 c3
  //  1967 6 1856 -58 1976 -64 120 -171 210 -299 253 l-66 23 -1770 1 c-974 1
  //  -1791 -2 -1817 -6z m1861 -1039 c14 -9 34 -30 45 -45 20 -27 21 -41 24 -511
  //  l3 -484 489 -3 489 -3 30 -29 c56 -54 64 -134 19 -191 -43 -54 -48 -55 -557
  //  -55 l-470 0 -3 -477 c-3 -438 -5 -481 -21 -511 -50 -91 -177 -96 -239 -10
  //  l-23 33 -3 483 -3 482 -470 0 c-509 0 -514 1 -557 55 -25 31 -37 84 -28 120 4
  //  14 22 43 41 63 l33 37 491 3 491 3 0 462 c0 273 4 477 10 498 25 90 135 133
  //  209 80z"/>
  //  </g>
  //  </svg>` 
    //'<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/><path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/></svg>'

    certificate.append(c_img)
    certificate.append(c_span)

    if(diamond['certificate_link'] != '')
    certificate.append(c_link)

    //g. price
    let price = document.createElement('div')
    price.classList.add('diamond-list-item')
    price.classList.add('diamond-price')
    price.innerHTML = formatDiamondSelectorMoney(diamond['price'])

    //h. view details
    let view_d = document.createElement('div')
    view_d.classList.add('diamond-list-item')
    view_d.classList.add('diamond-details')

    let view_d_title = document.createElement('div')
    view_d_title.classList.add('customize-inline')
    view_d_title.classList.add('customize-desktop')
    view_d_title.innerText = 'View Details'

    let view_d_span = document.createElement('span')
    view_d_span.id = 'Customize-Diamond-' + diamond['id']
    view_d_span.classList.add('diamond-details-span')
    view_d_span.classList.add('diamond-details-closed')

    view_d_span.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>'

    view_d.append(view_d_title)
    view_d.append(view_d_span)
    
    //Append Row
    row.append(img_small_container)
    row.append(cts)
    row.append(color)
    row.append(clarity)
    row.append(precision)
    row.append(certificate)
    row.append(price)
    row.append(view_d)

    //3. CREATE DETAILED VIEW

    let diamond_dv_wrapper = document.createElement('div')
    diamond_dv_wrapper.id = 'Diamond-Detailed-View-Wrapper-Diamond-' + diamond['id']
    diamond_dv_wrapper.classList.add('diamond-detailed-view-wrapper')
    if(grey)
    diamond_dv_wrapper.classList.add('diamond-row-grey')

    let dv_containers = document.createElement('div')
    dv_containers.classList.add('diamond-detailed-view-containers')

    let dv_container_1 = document.createElement('div')
    dv_container_1.classList.add('diamond-detailed-view-container-1')

    let dv_img_container = document.createElement('div')
    dv_img_container.classList.add('diamond-detailed-view-img')

    // a. dv img
    let dv_img = document.createElement('img')
  
    dv_img.id = "d_img_" + diamond['id']
    dv_img.src = diamond['img']
    dv_img.height = 208
    let dv_img_backup = 'https://lucce-storage.s3.ap-east-1.amazonaws.com/media/images/' + diamond['s3_img'] + '.jpg'

    let start = new Date()

    let interval = setInterval(()=>{checkPic(start,dv_img,interval,dv_img_backup)},100)

    dv_img.addEventListener('error',(e)=>{
      e.target.src = dv_img_backup
      Array.from(e.target.parentElement.querySelectorAll('span')).forEach(span=>span.remove())
    })

    //magnify img
    let magnify_img = document.createElement('span')
    magnify_img.classList.add('customize-magnify-img')
    magnify_img.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#afafaf" class="bi bi-search" viewBox="0 0 16 16">
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
  </svg>`

    magnify_img.addEventListener('click',()=>{
      document.getElementById('Customize-Large-Img-And-3d-Exit').querySelector('svg').style.fill = "#fff"
      let container = document.getElementById('Customize-Large-Img-And-3d-Container')
      container.style.display = 'block'
      container.style.backgroundColor = 'rgba(0,0,0,.85)'
      let iframe_viewer =document.getElementById('Customize-Iframe-Viewer')
      iframe_viewer.style.display = 'none'
      let img_viewer = document.getElementById('Customize-Large-Img-Viewer')
      img_viewer.style.display = 'block'
      img_viewer.src = diamond['img']

    })

    //3d-video 
    let icon_3d = document.createElement('span')
    icon_3d.classList.add('customize-icon-3d')
  //   icon_3d.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-badge-3d-fill" viewBox="0 0 16 16">
  //   <path d="M10.157 5.968h-.844v4.06h.844c1.116 0 1.621-.667 1.621-2.02 0-1.354-.51-2.04-1.621-2.04z"/>
  //   <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm5.184 4.368c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914h.663zM8.126 11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984H8.126V11z"/>
  // </svg>`
    icon_3d.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-play-btn-fill" viewBox="0 0 16 16">
    <path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2m6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z"/>
  </svg>`

  icon_3d.addEventListener('click',()=>{
    let text = "You are about to be redirected to another page";
    if (confirm(text) == true) {
      if(diamond['video'].includes('v360.diamonds')){
        window.open(diamond['video'])
      } else {
        window.open("https://api.luccerings.com/videos/" + diamond['id'])
      }
    }

 
    //Shopify headers blocking use of embeded iframes

    // document.getElementById('Customize-Large-Img-And-3d-Exit').querySelector('svg').style.fill = "#000"
    // let container = document.getElementById('Customize-Large-Img-And-3d-Container')
    // container.style.display = 'block'
    // container.style.backgroundColor = '#fff'
    // let img_viewer = document.getElementById('Customize-Large-Img-Viewer')
    // img_viewer.style.display = 'none'

    // let iframe_viewer =document.getElementById('Customize-Iframe-Viewer')
    // iframe_viewer.style.display = 'block'
    // iframe_viewer.src = diamond['video']
  })


    dv_img_container.append(dv_img)
    dv_img_container.append(magnify_img)
    if(diamond['video'] !== '' && diamond['video'].includes('diamx') == false)
    dv_img_container.append(icon_3d)
    dv_container_1.append(dv_img_container)


    // b.
    let dv_info = document.createElement('div')
    dv_info.classList.add('diamond-detailed-view-info')
    dv_info.classList.add('customize-wide-screen')

    //section 1
    let dv_info_section_1 = document.createElement('div')
    dv_info_section_1.classList.add('diamond-detailed-view-info-section-1')

    let dv_info_section_1_span = document.createElement('span')
    dv_info_section_1_span.classList.add('diamond-detailed-view-info-section-1-cts-cut')
    dv_info_section_1_span.innerHTML = diamond['cts'] + 'ct ' + capitalizeFirstLetter(diamond['shape'].toLowerCase()) + ' Diamond' + '<span style="margin-left:35px;">' + formatDiamondSelectorMoney(diamond['price']) + '</span>'

    dv_info_section_1.append(dv_info_section_1_span)
    dv_info.append(dv_info_section_1)

    
    //section 2
    let dv_info_section_2 = document.createElement('div')
    dv_info_section_2.classList.add('diamond-detailed-view-info-section-2')

    //section 2 - left
    let dv_info_section_2_left = document.createElement('div')
    dv_info_section_2_left.classList.add('diamond-detailed-view-info-section-2-left')

    let dv_info_section_2_left_span_1 = document.createElement('span')
    dv_info_section_2_left_span_1.classList.add('customize-margin-top-20')
    dv_info_section_2_left_span_1.innerText = 'Color:' + diamond['color']

    let dv_info_section_2_left_span_2 = document.createElement('span')
    dv_info_section_2_left_span_2.classList.add('customize-margin-top-50')
    dv_info_section_2_left_span_2.innerText = 'Clarity:' + diamond['clarity']

    dv_info_section_2_left.append(dv_info_section_2_left_span_1)
    dv_info_section_2_left.append(dv_info_section_2_left_span_2)

    


    //section 2 - middle
    let dv_info_section_2_middle = document.createElement('div')
    dv_info_section_2_middle.classList.add('diamond-detailed-view-info-section-2-middle')

    let slider_color_values = document.createElement('div')
    slider_color_values.id = 'Slider-Color-Values-Diamond-' + diamond['id']
    slider_color_values.classList.add('slider-color-values-detailed-view')

    //Add colors
    let span_champagne = document.createElement('span')
    span_champagne.innerText = 'Champagne'
    slider_color_values.append(span_champagne)

   

    for(let c = 0;c < color_keys.length; c++){
        let span = document.createElement('span')
        span.innerText = color_keys[c]
        slider_color_values.append(span)
    }

    let slider_range_color = document.createElement('div')
    slider_range_color.id = 'Slider-Range-Color-Diamond-' + diamond['id']
    slider_range_color.style.backgroundColor = '#000'
    slider_range_color.style.opacity = '1'
    slider_range_color.style.color = '#000'
    slider_range_color.style.height = '1px'


    let slider_color_desc = document.createElement('div')
    slider_color_desc.id = 'Slider-Color-Description-Diamond-' + diamond['id']
    slider_color_desc.classList.add('slider-color-description-detailed-view')

    let slider_color_desc_1 = document.createElement('span')
    slider_color_desc_1.innerText = 'Faint Color'
    slider_color_desc.append(slider_color_desc_1)

    let slider_color_desc_2 = document.createElement('span')
    slider_color_desc_2.innerText = 'Near Colorless'
    slider_color_desc.append(slider_color_desc_2)

    let slider_color_desc_3 = document.createElement('span')
    slider_color_desc_3.innerText = 'Colorless'
    slider_color_desc.append(slider_color_desc_3)

    let slider_clarity_values = document.createElement('div')
    slider_clarity_values.id = 'Slider-Clarity-Values-Diamond-' + diamond['id']
    slider_clarity_values.classList.add('slider-clarity-values-detailed-view')
    slider_clarity_values.classList.add('customize-margin-top-20')

    for(let c = 0;c < clarity_keys.length;c++){
        let span = document.createElement('span')
        span.innerText = clarity_keys[c]
        slider_clarity_values.append(span)
    }

    let slider_range_clarity = document.createElement('div')
    slider_range_clarity.id = 'Slider-Range-Clarity-Diamond-' + diamond['id']
    slider_range_clarity.style.backgroundColor = '#000'
    slider_range_clarity.style.opacity = '1'
    slider_range_clarity.style.color = '#000'
    slider_range_clarity.style.height = '1px'

    let slider_clarity_desc = document.createElement('div')
    slider_clarity_desc.classList.add('slider-clarity-description-detailed-view')
    
    let slider_clarity_desc_1 = document.createElement('span')
    slider_clarity_desc_1.innerText = 'Slightly Included'
    slider_clarity_desc.append(slider_clarity_desc_1)

    let slider_clarity_desc_2 = document.createElement('span')
    slider_clarity_desc_2.innerText = 'Very Slightly Included'
    slider_clarity_desc.append(slider_clarity_desc_2)

    let slider_clarity_desc_3 = document.createElement('span')
    slider_clarity_desc_3.innerText = 'Very Very Slightly Included'
    slider_clarity_desc.append(slider_clarity_desc_3)

    // let slider_clarity = document.createElement('div')
    // slider_clarity.id = 'Slider-Range-Clarity-Diamond-' + diamond['id']

    //color
    dv_info_section_2_middle.append(slider_color_values)
    dv_info_section_2_middle.append(slider_range_color)
    dv_info_section_2_middle.append(slider_color_desc)

    //clarity
    dv_info_section_2_middle.append(slider_clarity_values)
    dv_info_section_2_middle.append(slider_range_clarity)
    dv_info_section_2_middle.append(slider_clarity_desc)

    //section 2 - right
    let dv_info_section_2_right = document.createElement('div')
    dv_info_section_2_right.classList.add('diamond-detailed-view-info-section-2-right')




    appendDiamondGrading(dv_info_section_2_right, diamond);

    //append dv container 1
    dv_info_section_2.append(dv_info_section_2_left)
    dv_info_section_2.append(dv_info_section_2_middle)
    dv_info_section_2.append(dv_info_section_2_right)

    dv_info.append(dv_info_section_2)
    dv_container_1.append(dv_info)



    //Mobile
    // b.
    let mobile_dv_info = document.createElement('div')
    mobile_dv_info.classList.add('diamond-detailed-view-info')
    mobile_dv_info.classList.add('customize-mobile')

    //section 1
    let mobile_dv_info_section_1 = document.createElement('div')
    mobile_dv_info_section_1.classList.add('diamond-detailed-view-info-section-1')

    let mobile_dv_info_section_1_span = document.createElement('span')
    mobile_dv_info_section_1_span.classList.add('diamond-detailed-view-info-section-1-cts-cut')
    mobile_dv_info_section_1_span.innerText = diamond['cts'] + 'ct ' + capitalizeFirstLetter(diamond['shape'].toLowerCase()) + ' Diamond'

    mobile_dv_info_section_1.append(mobile_dv_info_section_1_span)
    mobile_dv_info.append(mobile_dv_info_section_1)

    
    //section 2
    let mobile_dv_info_section_2 = document.createElement('div')
    mobile_dv_info_section_2.classList.add('diamond-detailed-view-info-section-2')

    //section 2 - top
    let mobile_dv_info_section_2_top = document.createElement('div')
    mobile_dv_info_section_2_top.classList.add('diamond-detailed-view-info-section-2-top')

    //item 1
    let mobile_dv_item_1 = document.createElement('div')
    mobile_dv_item_1.classList.add('mobile-diamond-detailed-view-info-item')
    
    let mobile_dv_item_1_title = document.createElement('div')
    mobile_dv_item_1_title.classList.add('mobile-diamond-detailed-view-info-item-title')
    mobile_dv_item_1_title.innerHTML =  'Color:'+ diamond['color'] +'<span id="Mobile-Slider-Color-Values-Diamond-'+ diamond['id'] +'-Expand" class="customize-closed customize-details-expand">+</span>'

    let mobile_dv_item_1_contents_container = document.createElement('div')
    mobile_dv_item_1_contents_container.id = 'Mobile-Slider-Color-Values-Diamond-' + diamond['id'] + '-Contents-Container'
    mobile_dv_item_1_contents_container.classList.add('mobile-diamond-detailed-view-info-item-contents-container')

    let mobile_dv_item_1_contents = document.createElement('div')
    mobile_dv_item_1_contents.id = 'Mobile-Slider-Color-Values-Diamond-' + diamond['id'] + '-Contents'
    mobile_dv_item_1_contents.classList.add('mobile-diamond-detailed-view-info-item-contents')

    let mobile_dv_color_values = document.createElement('div')
    mobile_dv_color_values.id = 'Mobile-Slider-Color-Values-Diamond-' + diamond['id']
    mobile_dv_color_values.classList.add('slider-color-values-detailed-view')

      //Add colors
      let mobile_span_champagne = document.createElement('span')
      mobile_span_champagne.innerText = 'Champagne'
      mobile_dv_color_values.append(mobile_span_champagne)
  for(let c = 0;c < color_keys.length;c++){
      let span = document.createElement('span')
      let key = color_keys[c]
      if(key == 'G'){
        span.classList.add('mobile-color-g-details')
      }
      else if(key == 'F'){
        span.classList.add('mobile-color-f-details')
      }

      span.innerText = key
      mobile_dv_color_values.append(span)
  }

  let mobile_slider_range_color = document.createElement('div')
    mobile_slider_range_color.id = 'Mobile-Slider-Range-Color-Diamond-' + diamond['id']
    mobile_slider_range_color.style.height = '1px'
    mobile_slider_range_color.style.backgroundColor = '#000'
    mobile_slider_range_color.style.opacity = '1'
    mobile_slider_range_color.style.color = '#000'
    mobile_slider_range_color.classList.add('customize-slider-small')

    let mobile_slider_color_desc = document.createElement('div')
    mobile_slider_color_desc.id = 'Mobile-Slider-Color-Description-Diamond-' + diamond['id']
    mobile_slider_color_desc.classList.add('slider-color-description-detailed-view')

    let mobile_slider_color_desc_1 = document.createElement('span')
    mobile_slider_color_desc_1.innerText = 'Faint Color'
    mobile_slider_color_desc.append(mobile_slider_color_desc_1)

    let mobile_slider_color_desc_2 = document.createElement('span')
    mobile_slider_color_desc_2.innerText = 'Near Colorless'
    mobile_slider_color_desc.append(mobile_slider_color_desc_2)

    let mobile_slider_color_desc_3 = document.createElement('span')
    mobile_slider_color_desc_3.innerText = 'Colorless'
    mobile_slider_color_desc.append(mobile_slider_color_desc_3)

    mobile_dv_item_1_contents.append(mobile_dv_color_values)
    mobile_dv_item_1_contents.append(mobile_slider_range_color)
    mobile_dv_item_1_contents.append(mobile_slider_color_desc)

    mobile_dv_item_1_contents_container.append(mobile_dv_item_1_contents)
    
    mobile_dv_item_1.append(mobile_dv_item_1_title)
    mobile_dv_item_1.append(mobile_dv_item_1_contents_container)

    mobile_dv_info_section_2_top.append(mobile_dv_item_1)
    

    //section 2 -  middle
    let mobile_dv_info_section_2_middle = document.createElement('div')
    mobile_dv_info_section_2_middle.classList.add('mobile-diamond-detailed-view-info-section-2-middle')

    //item 2
    let mobile_dv_item_2 = document.createElement('div')
    mobile_dv_item_2.classList.add('mobile-diamond-detailed-view-info-item')
    
    let mobile_dv_item_2_title = document.createElement('div')
    mobile_dv_item_2_title.classList.add('mobile-diamond-detailed-view-info-item-title')
    mobile_dv_item_2_title.innerHTML = 'Clarity:'+ diamond['clarity'] +'<span id="Mobile-Slider-Clarity-Values-Diamond-'+diamond['id']+'-Expand" class="customize-closed customize-details-expand">+</span>'

    let mobile_dv_item_2_contents_container = document.createElement('div')
    mobile_dv_item_2_contents_container.id = 'Mobile-Slider-Clarity-Values-Diamond-' + diamond['id'] + '-Contents-Container'
    mobile_dv_item_2_contents_container.classList.add('mobile-diamond-detailed-view-info-item-contents-container')

    let mobile_dv_item_2_contents = document.createElement('div')
    mobile_dv_item_2_contents.id = 'Mobile-Slider-Clarity-Values-Diamond-' + diamond['id'] + '-Contents'
    mobile_dv_item_2_contents.classList.add('mobile-diamond-detailed-view-info-item-contents')

    let mobile_dv_clarity_values = document.createElement('div')
    mobile_dv_clarity_values.id = 'Mobile-Slider-Clarity-Values-Diamond-' + diamond['id']
    mobile_dv_clarity_values.classList.add('slider-clarity-values-detailed-view')
    mobile_dv_clarity_values.classList.add('customize-margin-top-20')

      //Add clarity values
      for(let c = 0;c < clarity_keys.length;c++){
        let span = document.createElement('span')
        let key = clarity_keys[c]
        span.innerText = key

        if(key == 'VS1'){
          span.classList.add('mobile-clarity-vs1-details')
        } else if(key == 'VVS1'){
          span.classList.add('mobile-clarity-vvs1-details')
        } else if(key == 'VVS2'){
          span.classList.add('mobile-clarity-vvs2-details')
        } else if(key == 'IF'){
          span.classList.add('mobile-clarity-if-details')
        }
        
        mobile_dv_clarity_values.append(span)
    }
      
  let mobile_slider_range_clarity = document.createElement('div')
    mobile_slider_range_clarity.id = 'Mobile-Slider-Range-Clarity-Diamond-' + diamond['id']
    mobile_slider_range_clarity.style.height = '1px'
    mobile_slider_range_clarity.style.backgroundColor = '#000'
    mobile_slider_range_clarity.style.opacity = '1'
    mobile_slider_range_clarity.style.color = '#000'
    mobile_slider_range_clarity.classList.add('customize-slider-small')
    

    let mobile_slider_clarity_desc = document.createElement('div')
    mobile_slider_clarity_desc.id = 'Mobile-Slider-Clarity-Description-Diamond-' + diamond['id']
    mobile_slider_clarity_desc.classList.add('slider-clarity-description-detailed-view')

    let mobile_slider_clarity_desc_1 = document.createElement('span')
    mobile_slider_clarity_desc_1.innerText = 'Slightly Included'
    mobile_slider_clarity_desc.append(mobile_slider_clarity_desc_1)

    let mobile_slider_clarity_desc_2 = document.createElement('span')
    mobile_slider_clarity_desc_2.innerText = 'Very Slightly Included'
    mobile_slider_clarity_desc.append(mobile_slider_clarity_desc_2)

    let mobile_slider_clarity_desc_3 = document.createElement('span')
    mobile_slider_clarity_desc_3.innerText = 'Very Very Slightly Included'
    mobile_slider_clarity_desc.append(mobile_slider_clarity_desc_3)

    mobile_dv_item_2_contents.append(mobile_dv_clarity_values)
    mobile_dv_item_2_contents.append(mobile_slider_range_clarity)
    mobile_dv_item_2_contents.append(mobile_slider_clarity_desc)

    mobile_dv_item_2_contents_container.append(mobile_dv_item_2_contents)
    
    mobile_dv_item_2.append(mobile_dv_item_2_title)
    mobile_dv_item_2.append(mobile_dv_item_2_contents_container)

    mobile_dv_info_section_2_middle.append(mobile_dv_item_2)

    //section 2 -  bottom
    let mobile_dv_info_section_2_bot = document.createElement('div')
    mobile_dv_info_section_2_bot.classList.add('diamond-detailed-view-info-section-2-bottom')

    //item 3
    let mobile_dv_item_3 = document.createElement('div')
    mobile_dv_item_3.classList.add('mobile-diamond-detailed-view-info-item')
    
    let mobile_dv_item_3_title = document.createElement('div')
    mobile_dv_item_3_title.classList.add('mobile-diamond-detailed-view-info-item-title')
    mobile_dv_item_3_title.innerHTML = 'View More Details <span id="Mobile-Slider-Other-Values-Diamond-'+diamond['id']+'-Expand" class="customize-closed customize-details-expand">+</span>'

    let mobile_dv_item_3_contents_container = document.createElement('div')
    mobile_dv_item_3_contents_container.id = 'Mobile-Slider-Other-Values-Diamond-' + diamond['id'] + '-Contents-Container'
    mobile_dv_item_3_contents_container.classList.add('mobile-diamond-detailed-view-info-item-contents-container')

    let mobile_dv_item_3_contents = document.createElement('div')
    mobile_dv_item_3_contents.id = 'Mobile-Slider-Other-Values-Diamond-' + diamond['id'] + '-Contents'
    mobile_dv_item_3_contents.classList.add('mobile-diamond-detailed-view-info-item-contents')
    mobile_dv_item_3_contents.style.lineHeight = 'normal'

    let mobile_dv_other_values = document.createElement('div')
    mobile_dv_other_values.classList.add('mobile-diamond-detailed-view-info-item-contents-other')


    appendDiamondGrading(mobile_dv_other_values, diamond);

    mobile_dv_item_3_contents.append(mobile_dv_other_values)


    mobile_dv_item_3_contents_container.append(mobile_dv_item_3_contents)
    
    mobile_dv_item_3.append(mobile_dv_item_3_title)
    mobile_dv_item_3.append(mobile_dv_item_3_contents_container)

    mobile_dv_info_section_2_bot.append(mobile_dv_item_3)
    
    mobile_dv_info_section_2.append(mobile_dv_info_section_2_top)
    mobile_dv_info_section_2.append(mobile_dv_info_section_2_middle)
    mobile_dv_info_section_2.append(mobile_dv_info_section_2_bot)

    mobile_dv_info.append(mobile_dv_info_section_2)
    dv_container_1.append(mobile_dv_info)

    //Container2/BTNS

    let dv_container_2 = document.createElement('div')
    dv_container_2.classList.add('diamond-detailed-view-container-2')

    let detail_btns = document.createElement('div')
    detail_btns.classList.add('diamond-detailed-view-btns')

    let detail_btn_1 = document.createElement('div')
    detail_btn_1.classList.add('diamond-detailed-view-specialist-btn')
    detail_btn_1.innerText = 'SPEAK WITH A SPECIALIST'

    detail_btn_1.addEventListener('click',()=>{
      location.href = 'https://luccerings.com/pages/set-an-appointment-with-us'
    })

    let detail_btn_2 = document.createElement('div')
    detail_btn_2.id = 'Diamond-Detailed-View-Buy-Btn-' + diamond['id']
    detail_btn_2.classList.add('diamond-detailed-view-buy-btn')
    detail_btn_2.innerHTML = formatDiamondSelectorMoney(diamond['price']) +' - ADD THIS DIAMOND'

    //diamond selected
    detail_btn_2.addEventListener('click',()=>{createDiamondShopify(diamond)})

    detail_btns.append(detail_btn_1)
    detail_btns.append(detail_btn_2)

    dv_container_2.append(detail_btns)

    dv_containers.append(dv_container_1)
    dv_containers.append(dv_container_2)

    diamond_dv_wrapper.append(dv_containers)


    //FINAL
    diamond_list.append(row)
    diamond_list.append(diamond_dv_wrapper)
}

async function createDiamondShopify(diamond){
    let btn = document.getElementById('Diamond-Detailed-View-Buy-Btn-' + diamond['id'])
    let btn_original_text = btn.innerHTML
    let height = btn.getBoundingClientRect().height
    btn.style.height = height + 'px'
    btn.innerHTML = `<div style="visibility:visible;" class="filter-customize-loader-container">
    <div class="buy-customize-loader" title="1">
    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_6kVp{transform-origin:center;animation:spinner_irSm .75s infinite linear}@keyframes spinner_irSm{100%{transform:rotate(360deg)}}</style><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" class="spinner_6kVp"/></svg>
    </div>
  </div>`

    // //send diamond id, lab number to lucce api
    // let data = {
    //   id:diamond['id'],
    //   numb:diamond['certificate_number'],
    //   code:'1c3f96c0981de4b7f2fd4f505bd4d1493b4660c07203f786b5f133ddc9fa53eb0f6c551b',
    // }

    // fetch(web_server +'/create_diamond',
    //       {method: 'POST',body: JSON.stringify(data)}
    //       )
    // .then(resp=>resp.json())
    // .then(data=>{
    //   let d_select_img_small = diamond['img']
    //   // if(d_select_img_small == ''){
    //   //   d_select_img_small = 'https://ssdweb.co/ssdweb/hd/imaged/923830005/still.jpg'
    //   // }

    //   let metal = url.searchParams.get('metal')
    //   let size = url.searchParams.get('size')
    //   let engravings = url.searchParams.get('engravings')
    //   let handle = url.searchParams.get('handle')
      
    //   //redirect user back to products page with selected diamond
    //   location.href = '/products/' + handle + '?cts=' + diamond['cts'] +
    //   '&color=' + diamond['color'] + '&clarity=' + diamond['clarity'] +
    //   '&metal=' + metal + '&size=' + size +
    //   '&lab=' + diamond['certificate'] + '&lab_numb=' + diamond['certificate_number'] +
    //   '&fluorescent=' + encodeURIComponent(diamond['fluorescent'] || '') +
    //   '&img='+ d_select_img_small + '&price=' + diamond['price'] + '&selected=Y&' + 'diamond_id=' + data['diamond_id'] + 
    //   '&id=' + diamond['id'] + '&engravings=' + encodeURIComponent(engravings)
    
    // })
    // .catch(err=>{
    //   btn.innerHTML = 'Error'

    //   setTimeout(()=>{
    //     btn.innerHTML = btn_original_text
    //   },1000)
    // })

    let metal = url.searchParams.get('metal')
    let size = url.searchParams.get('size')
    let engravings = url.searchParams.get('engravings')
    let handle = url.searchParams.get('handle')
    let d1 = url.searchParams.get('d1')
    let d2 = url.searchParams.get('d2')
    let d2click = url.searchParams.get('d2click')
    let earrings = url.searchParams.get('earrings')

    let d1_details
    if(d1 == 'Y'){
      d1_details = getDiamond1Details()
    } else {
      d1_details = ''
    }
    let d2_details
    if(d2 == 'Y'){
      d2_details = getDiamond2Details()
    } else {
      d2_details = ''
    }

    if(earrings == 'true'){
      //only for earrings 2 diamond selection
      let lab = url.searchParams.get('lab')
      let lab_n = url.searchParams.get('lab_numb')
    
      if(diamond['certificate'] + diamond['certificate_number'] !== lab + lab_n){
          let diamond_s3_img_url = 'https://lucce-storage.s3.ap-east-1.amazonaws.com/media/thumbnails/thumb-' + diamond['s3_img'] + '.jpg'
          if(d2click == 'true'){
            location.href = '/products/' + handle + '?cts2=' + diamond['cts'] +
            '&color2=' + diamond['color'] + '&clarity2=' + diamond['clarity'] +
            '&metal=' + metal + '&size=' + size +
            '&lab2=' + diamond['certificate'] + '&lab_numb2=' + diamond['certificate_number'] +
            '&fluorescent2=' + encodeURIComponent(diamond['fluorescent'] || '') +
            '&cut_precision2=' + encodeURIComponent(diamond['cut_precision'] || '') +
            '&polish2=' + encodeURIComponent(diamond['polish'] || '') +
            '&symmetry2=' + encodeURIComponent(diamond['symmetry'] || '') +
            '&img2='+ diamond['img'] + '&price2=' + diamond['price'] + '&selected=Y' + 
            '&id2=' + diamond['id'] + '&engravings=' + encodeURIComponent(engravings) +
            '&earrings=true&d1=' + d1 + '&d2=Y' + d1_details + '&diamond_type=' + diamond_type 
          } else {
            location.href = '/products/' + handle + '?cts=' + diamond['cts'] +
            '&color=' + diamond['color'] + '&clarity=' + diamond['clarity'] +
            '&metal=' + metal + '&size=' + size +
            '&lab=' + diamond['certificate'] + '&lab_numb=' + diamond['certificate_number'] +
            '&fluorescent=' + encodeURIComponent(diamond['fluorescent'] || '') +
            '&cut_precision=' + encodeURIComponent(diamond['cut_precision'] || '') +
            '&polish=' + encodeURIComponent(diamond['polish'] || '') +
            '&symmetry=' + encodeURIComponent(diamond['symmetry'] || '') +
            '&img='+ diamond['img'] + '&price=' + diamond['price'] + '&selected=Y' + 
            '&id=' + diamond['id'] + '&engravings=' + encodeURIComponent(engravings) +
            '&earrings=true&&d1=Y' + '&d2=' + d2 + d2_details + '&diamond_type=' + diamond_type 
          }
      }
      else{
        window.alert('This diamond has already been selected')
        btn.innerHTML = ""
      }
     

    } else if(all_cut){
      //send diamond id, lab number to lucce api
      let get_previous_items_data = await get_previous_items()
      let existing_citems = parse_previous_items(get_previous_items_data)
      let data = {
        id:diamond['id'],
        earrings:'N',
        engravings: 'N',
        engravings_msg:'',
        numb:diamond['certificate_number'],
        code:'1c3f96c0981de4b7f2fd4f505bd4d1493b4660c07203f786b5f133ddc9fa53eb0f6c551b',
        existing_items:existing_citems
      }

      fetch(web_server +'/create_diamond',
            {method: 'POST',body: JSON.stringify(data)}
            )
      .then(resp=>resp.json())
      .then(data=>{
        location.href = '/cart/'+ data['diamond_id'] + ':1' + data['existing_items'] + '?storefront=true'
      })
      .catch(err=>{
        btn.innerHTML = 'Error'

        setTimeout(()=>{
          btn.innerHTML = btn_original_text
        },1000)
      })

    } 
    else {
      //normal single diamond selection
      let diamond_s3_img_url = 'https://lucce-storage.s3.ap-east-1.amazonaws.com/media/thumbnails/thumb-' + diamond['s3_img'] + '.jpg'
      
      location.href = '/products/' + handle + '?cts=' + diamond['cts'] +
      '&color=' + diamond['color'] + '&clarity=' + diamond['clarity'] +
      '&metal=' + metal + '&size=' + size +
      '&lab=' + diamond['certificate'] + '&lab_numb=' + diamond['certificate_number'] +
            '&fluorescent=' + encodeURIComponent(diamond['fluorescent'] || '') +
            '&cut_precision=' + encodeURIComponent(diamond['cut_precision'] || '') +
            '&polish=' + encodeURIComponent(diamond['polish'] || '') +
            '&symmetry=' + encodeURIComponent(diamond['symmetry'] || '') +
      '&img='+ diamond['img'] + '&price=' + diamond['price'] + '&selected=Y' + 
      '&id=' + diamond['id'] + '&engravings=' + encodeURIComponent(engravings) + '&diamond_type=' + diamond_type 
    }

    
    

}



function addDiamondEventListners(diamond){


let g_scale = 0
let f_scale = 0

let mobile_color_scale_static = {
    'J':329,
    'I':431,
    'H':537,
    'G': g_scale,//599
    'F':f_scale,//730
    'E':860,
    'D':1000,
  }

    
  let mobile_clarity_scale_static = {
    'SI2':29,
    'SI1':156,
    'VS2':293,
    'VS1':437,
    'VVS2':594,
    'VVS1':743,
    'IF':877,
    'FL':1000,
  }


//OPEN - CLOSE DETAILED VIEW
let details_open_close = document.getElementById('Customize-Diamond-' + diamond['id'])

details_open_close.addEventListener('click',(e)=>{listenerOpenCloseDiamondDetails(e,diamond['color'],diamond['clarity'],diamond['id'])})


//Sliders
let static_colors = Array.from(document.getElementById('Slider-Color-Values-Diamond-'+diamond['id']).querySelectorAll('span'))
highlightColor(diamond['color'],static_colors)

//Detailed View Slider
  //Color Slider
  // $( "#Slider-Range-Color-Diamond-"+diamond['id'] ).slider({
  //   disabled: true,
  //   range: false,
  //   min: 0,
  //   max: 1000,
  //   value: color_scale_static[diamond['color']],
  //   slide: function( event, ui ) {}
  // });


  let static_clarity = Array.from(document.getElementById('Slider-Clarity-Values-Diamond-'+diamond['id']).querySelectorAll('span'))
  highlightClarity(diamond['clarity'],static_clarity)


  //Color Slider
  // $( "#Slider-Range-Clarity-Diamond-"+diamond['id'] ).slider({
  //   disabled: true,
  //   range: false,
  //   min: 0,
  //   max: 1000,
  //   value: clarity_scale_static[diamond['clarity']],
  //   slide: function( event, ui ) {
  //   }
  // });


  //Mobile Slider - Detailed View
  let mobile_static_colors = Array.from(document.getElementById('Mobile-Slider-Color-Values-Diamond-'+diamond['id']).querySelectorAll('span')) 
  highlightColor(diamond['color'],mobile_static_colors)
  
  //Detailed View Slider
    //Color Slider
    // $( "#Mobile-Slider-Range-Color-Diamond-"+diamond['id'] ).slider({
    //   disabled: true,
    //   range: false,
    //   min: 0,
    //   max: 1000,
    //   value: mobile_color_scale_static[diamond['color']],
    //   slide: function( event, ui ) {}
    // });


    let mobile_static_clarity = Array.from(document.getElementById('Mobile-Slider-Clarity-Values-Diamond-'+diamond['id']).querySelectorAll('span'))
    highlightClarity(diamond['clarity'],mobile_static_clarity)
  
  
    //Color Slider
    // $( "#Mobile-Slider-Range-Clarity-Diamond-"+diamond['id'] ).slider({
    //   disabled: true,
    //   range: false,
    //   min: 0,
    //   max: 1000,
    //   value: mobile_clarity_scale_static[diamond['clarity']],
    //   slide: function( event, ui ) {}
    // });

    let detailed_view_wrapper = document.getElementById('Diamond-Detailed-View-Wrapper-Diamond-' + diamond['id'])
    let color_contents_expand = document.getElementById('Mobile-Slider-Color-Values-Diamond-'+diamond['id']+'-Expand')
    let color_contents = document.getElementById('Mobile-Slider-Color-Values-Diamond-'+diamond['id']+'-Contents-Container')
    let clarity_contents_expand = document.getElementById('Mobile-Slider-Clarity-Values-Diamond-'+diamond['id']+'-Expand')
    let clarity_contents = document.getElementById('Mobile-Slider-Clarity-Values-Diamond-'+diamond['id']+'-Contents-Container')
    let other_contents_expand = document.getElementById('Mobile-Slider-Other-Values-Diamond-'+diamond['id']+'-Expand')
    let other_contents = document.getElementById('Mobile-Slider-Other-Values-Diamond-'+diamond['id']+'-Contents-Container')
    toggleDiamondContents(color_contents,color_contents_expand,detailed_view_wrapper)
    toggleDiamondContents(clarity_contents,clarity_contents_expand,detailed_view_wrapper)
    toggleDiamondContents(other_contents,other_contents_expand,detailed_view_wrapper)

    //checkMobileColors(diamond['color'],diamond['id'])

}

function listenerOpenCloseDiamondDetails(e,color,clarity,id){
  e.stopPropagation();
  

  if(e.target.parentElement.nodeName.toLowerCase() === 'span'){
    //closed
    if(e.target.parentElement.classList.contains('diamond-details-closed')){
      openDiamondDetails(e.target.parentElement,id)
   
    } else {
      closeDiamondDetails(e.target.parentElement,id)
    }
 
  } 
  else if(e.target.nodeName.toLowerCase() === 'span'){
    //closed
    if(e.target.classList.contains('diamond-details-closed')){
      openDiamondDetails(e.target,id)
   
    } else {
      closeDiamondDetails(e.target,id)
    }
  }
  else {
    if(e.target.parentElement.parentElement.nodeName.toLowerCase() === 'span'){

      //closed
    if(e.target.parentElement.parentElement.classList.contains('diamond-details-closed')){
      openDiamondDetails(e.target.parentElement.parentElement,id)
   
    } else {
      closeDiamondDetails(e.target.parentElement.parentElement,id)

    }
    }
  }

  // checkMobileColors(color,id)
  // checkMobileClarity(clarity,id)
}

function rowListenerOpenCloseDiamondDetails(e,color,clarity,id){
  e.stopPropagation();


  if(e.target.nodeName !== 'path' && e.target.nodeName !== 'a'){ 
    let span = document.getElementById('Customize-Diamond-' + id)
    if(span.classList.contains('diamond-details-closed')){
      openDiamondDetails(span,id)
   
    } else {
      closeDiamondDetails(span,id)
    }

  }

  // checkMobileColors(color,id)
  // checkMobileClarity(clarity,id)
}

function openDiamondDetails(elem,id){
    let detailed_view_wrapper = document.getElementById('Diamond-Detailed-View-Wrapper-Diamond-' + id)
    elem.classList.remove('diamond-details-closed')
    elem.classList.add('diamond-details-open')
  
    elem.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
  </svg>`
    
    if(window.innerWidth < wide_screen_min_width ){
      let height = detailed_view_wrapper.querySelector('.diamond-detailed-view-container-1').getBoundingClientRect().height + 
      detailed_view_wrapper.querySelector('.diamond-detailed-view-container-2').getBoundingClientRect().height

      let wrapper_height = wrapper.getBoundingClientRect().height + height + 'px'
      wrapper.style.height = wrapper_height
      main_content.style.height = wrapper_height
      
      detailed_view_wrapper.style.height = height + 'px'
    }else {
      let wrapper_height = wrapper.getBoundingClientRect().height + 297 + 'px'
      wrapper.style.height = wrapper_height
      main_content.style.height = wrapper_height
      detailed_view_wrapper.style.height = '297px'
    }
  
  }
  
  function closeDiamondDetails(elem,id){
    let detailed_view_wrapper = document.getElementById('Diamond-Detailed-View-Wrapper-Diamond-' + id)
    elem.classList.remove('diamond-details-open')
    elem.classList.add('diamond-details-closed')
  
    elem.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
  </svg>`

    detailed_view_wrapper.style.height = '0'
  
    if(window.innerWidth < wide_screen_min_width){
      let height = detailed_view_wrapper.querySelector('.diamond-detailed-view-container-1').getBoundingClientRect().height + 
      detailed_view_wrapper.querySelector('.diamond-detailed-view-container-2').getBoundingClientRect().height

      let wrapper_height = wrapper.getBoundingClientRect().height - height + 'px'
      wrapper.style.height = wrapper_height
      main_content.style.height = wrapper_height
    }else {
      let wrapper_height = wrapper.getBoundingClientRect().height - 297 + 'px'
      wrapper.style.height = wrapper_height
      main_content.style.height = wrapper_height
    }
  
  }


  function highlightColor(color,array){

    let colors = {
      'J':1,
      'I':2,
      'H':3,
      'G':4,
      'F':5,
      'E':6,
      'D':7,
    }

  
        if(colors[color]){
            let elem = array[colors[color]]
            elem.classList.add('diamond-detail-highlighted')

            let slider_wheel = document.createElement('span')
            slider_wheel.classList.add('customize-slider-wheel')
            elem.append(slider_wheel)


            if(color == 'D'){
              array[colors[color]].style.marginRight = '-8px'
            }
          }

    
  }

  function highlightClarity(clarity,array){
    let clarity_list = {
      'SI2':0,
      'SI1':1,
      'VS2':2,
      'VS1':3,
      'VVS2':4,
      'VVS1':5,
      'IF':6,
      'FL':7,
    }

   
        if(clarity_list[clarity]){
            let elem = array[clarity_list[clarity]]
            elem.classList.add('diamond-detail-highlighted')

            let slider_wheel = document.createElement('span')
            slider_wheel.classList.add('customize-slider-wheel')
            elem.append(slider_wheel)
          }

   
  }

  function checkMobileColors(color,id){
    //this function sets the position of the Color Range Slider on mobile detailed view
    
    if(color == 'G' || color == 'F'){
      
      //small offset
      let ex = 1.5 + (3.75 * (1000/window.innerWidth))

      let color_values =document.getElementById('Mobile-Slider-Color-Values-Diamond-'+id)

      //Element to match position
      mobile_g = color_values.querySelector(".mobile-color-g-details")

      //Element to match position
      mobile_f = color_values.querySelector(".mobile-color-f-details")

      let slider = document.getElementById('Mobile-Slider-Range-Color-Diamond-'+id)
    
      //range slider has 0-1000 value.  Divide this by the pixels of the slider
      let scale = 1000/(slider.getBoundingClientRect().width)
      let g_pixels = (mobile_g.getBoundingClientRect().left - slider.getBoundingClientRect().left +ex)
      let f_pixels = (mobile_f.getBoundingClientRect().left - slider.getBoundingClientRect().left + ex)
      //postion = pixels * scale + half the element
      g_scale = g_pixels * scale + (mobile_g.getBoundingClientRect().width/2)
      f_scale = f_pixels * scale + (mobile_f.getBoundingClientRect().width/2)

    
      if(color == 'G')
      {
          $( "#Mobile-Slider-Range-Color-Diamond-"+id ).slider( "option", "value", g_scale );
      } 
      else if (color == 'F') {
          $( "#Mobile-Slider-Range-Color-Diamond-"+id ).slider( "option", "value", f_scale );
      }   
  }
    
}

function checkMobileClarity(clarity,id){
  //this function sets the position of the Color Range Slider on mobile detailed view
  
    //small offset
    let ex = 1.5 + (3.75 * (1000/window.innerWidth))

    let clarity_values =document.getElementById('Mobile-Slider-Clarity-Values-Diamond-'+id)

    //Element to match position
    mobile_vs1 = clarity_values.querySelector(".mobile-clarity-vs1-details")

    //Element to match position
    mobile_vvs2 = clarity_values.querySelector(".mobile-clarity-vvs2-details")

    //Element to match position
    mobile_vvs1 = clarity_values.querySelector(".mobile-clarity-vvs1-details")

    //Element to match position
    mobile_if = clarity_values.querySelector(".mobile-clarity-if-details")


    let slider = document.getElementById('Mobile-Slider-Range-Clarity-Diamond-'+id)
  
    //range slider has 0-1000 value.  Divide this by the pixels of the slider
    let scale = 1000/(slider.getBoundingClientRect().width)
    let vs1_pixels = (mobile_vs1.getBoundingClientRect().left - slider.getBoundingClientRect().left +ex)
    let vvs2_pixels = (mobile_vvs2.getBoundingClientRect().left - slider.getBoundingClientRect().left + ex)
    let vvs1_pixels = (mobile_vvs1.getBoundingClientRect().left - slider.getBoundingClientRect().left + ex)
    let if_pixels = (mobile_if.getBoundingClientRect().left - slider.getBoundingClientRect().left + ex)

    //postion = pixels * scale + half the element
    let vs1_scale = vs1_pixels * scale + (mobile_g.getBoundingClientRect().width/2)
    let vvs2_scale = vvs2_pixels * scale + (mobile_g.getBoundingClientRect().width/2)
    let vvs1_scale = vvs1_pixels * scale + (mobile_g.getBoundingClientRect().width/2)
    let if_scale = if_pixels * scale + (mobile_f.getBoundingClientRect().width/2)

  
    if(clarity='VS1')
    {
        $( "#Mobile-Slider-Range-Clarity-Diamond-"+id ).slider( "option", "value", vs1_scale );
    } 
    else if (clarity == 'VVS1') {
        $( "#Mobile-Slider-Range-Clarity-Diamond-"+id ).slider( "option", "value", vvs1_scale );
    }
    else if(clarity=='VVS2')
    {
        $( "#Mobile-Slider-Range-Clarity-Diamond-"+id ).slider( "option", "value", vvs2_scale );
    }
    else if(clarity=='IF')
    {
        $( "#Mobile-Slider-Range-Clarity-Diamond-"+id ).slider( "option", "value", if_scale );
    }   

  
}


function toggleDiamondContents(elem,btn,detailed_view_wrapper){
    btn.addEventListener('click',(e)=>{
      e.stopPropagation()
     
        if(btn.classList.contains('customize-closed')){
          if(elem.getBoundingClientRect().height == 0){
            //show slider wheel
            let slider_wheel = elem.querySelector('.mobile-diamond-detailed-view-info-item-contents')
            if(slider_wheel){
              slider_wheel.style.opacity = '1'
            }

            btn.classList.remove('customize-closed')
            btn.innerText = "-"

            let detailed_view_wrapper_height = detailed_view_wrapper.getBoundingClientRect().height

              detailed_view_wrapper.style.height =  detailed_view_wrapper_height + 98 + 'px'
              let wrapper_height = wrapper.getBoundingClientRect().height + 98 + 'px'
              wrapper.style.height = wrapper_height
              main_content.style.height = wrapper_height
              elem.style.height = 98 + 'px'
              elem.style.width = elem.getBoundingClientRect().width + 'px'
            }
            
           
        } else {
          if(elem.getBoundingClientRect().height == 98){
            //hide slider wheel
            let slider_wheel = elem.querySelector('.mobile-diamond-detailed-view-info-item-contents')
            if(slider_wheel){
              slider_wheel.style.opacity = '0'
            }
           
             
         

            btn.classList.add('customize-closed')
            btn.innerText = "+"
            elem_height = 0
            
            detailed_view_wrapper.style.height = detailed_view_wrapper.getBoundingClientRect().height - 98 + 'px'
            let wrapper_height = wrapper.getBoundingClientRect().height - 98 + 'px'
            wrapper.style.height = wrapper_height
            main_content.style.height = wrapper_height
            elem.style.height = 0 + 'px'
            elem.style.width = elem.getBoundingClientRect().width + 'px'
            }
        }
    })
}

function getLoadingTimeOut(start){
  let end = new Date()
  let time_out = 1000 - (end-start)

  if(time_out < 0){
    time_out = 0
  }

  return time_out

}

// function convertToSlug(Text) {
//   Text = Text.normalize("NFD")
//   return Text.toLowerCase().replace(/ /g,'-').replace(/[-]+/g, '-').replace(/[^\w-]+/g,'');
// }

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}



//for earrings only
function getDiamond1Details(){
  price = url.searchParams.get('price')
  let cts = url.searchParams.get('cts')
  let color = url.searchParams.get('color')
  let clarity = url.searchParams.get('clarity')
  let lab = url.searchParams.get('lab')
  let lab_n = url.searchParams.get('lab_numb')
  let img = url.searchParams.get('img')
  let id = url.searchParams.get('id')

  let params = '&cts=' + cts +
  '&color=' + color + '&clarity=' + clarity +
  '&metal=' + metal + '&size=' + size +
  '&lab=' + lab + '&lab_numb=' + lab_n + 
  '&img='+ img + '&price=' + price + 
  '&id=' + id

  params += '&fluorescent=' + encodeURIComponent(url.searchParams.get('fluorescent') || '')
  params += '&cut_precision=' + encodeURIComponent(url.searchParams.get('cut_precision') || '')
  params += '&polish=' + encodeURIComponent(url.searchParams.get('polish') || '')
  params += '&symmetry=' + encodeURIComponent(url.searchParams.get('symmetry') || '')
  return params
}

function getDiamond2Details(){
  price = url.searchParams.get('price')
  let cts = url.searchParams.get('cts')
  let color = url.searchParams.get('color')
  let clarity = url.searchParams.get('clarity')
  let lab = url.searchParams.get('lab')
  let lab_n = url.searchParams.get('lab_numb')
  let img = url.searchParams.get('img')
  let id = url.searchParams.get('id')

  let params = '&cts2=' + cts +
  '&color2=' + color + '&clarity2=' + clarity +
  '&metal=' + metal + '&size=' + size +
  '&lab2=' + lab + '&lab_numb2=' + lab_n + 
  '&img2='+ img + '&price2=' + price + 
  '&id2=' + id

  params += '&fluorescent2=' + encodeURIComponent(url.searchParams.get('fluorescent') || '')
  params += '&cut_precision2=' + encodeURIComponent(url.searchParams.get('cut_precision') || '')
  params += '&polish2=' + encodeURIComponent(url.searchParams.get('polish') || '')
  params += '&symmetry2=' + encodeURIComponent(url.searchParams.get('symmetry') || '')
  return params
}




function checkPic(start,pic,interval,s3_img){
    let time = new Date()
    if (pic.complete){
        clearInterval(interval)
        return 
    } else{
        if((time-start)/1000 > 6){
            clearInterval(interval)
            return useS3Backup(pic,s3_img)
        }
        return 
    }
}


function useS3Backup(ele,img){
  ele.src = img
}



//ALL CUTS
let shape_filter_section = document.getElementById("Customize-Shape-Filter-Section")
let shape_filter_list = Array.from(shape_filter_section.querySelectorAll('.shape-filter-name'))

shape_filter_list.forEach(shape=>{
  shape.addEventListener('click',(e)=>{
    shape_filter_list.forEach(obj=>obj.classList.remove('shape-filter-selected'))

    let obj_target
    if(e.target.classList.contains('shape-filter-name')){
      obj_target = e.target
    }
    else if(e.target.parentElement.classList.contains('shape-filter-name')){
      obj_target = e.target.parentElement
    }
    else if(e.target.parentElement.parentElement.classList.contains('shape-filter-name')){
      obj_target = e.target.parentElement.parentElement
    }

    obj_target.classList.add('shape-filter-selected')

    let shape = obj_target.id
    //Customize-Shape-
    shape = shape.substring(16)
    diamond_shape = shape.toUpperCase()

   

    if(obj_target){
      if(diamond_type != '1'){
        update_filters()
      } else {
        update_filters_natural()
      }

      let custom_event = new Event('change')
      let filter_container = document.getElementById('Customize-Filter-Container')
      filter_container.dispatchEvent(custom_event)
    }

    
  })
})

document.getElementById('Filter-Source-Btn-Lab').addEventListener('click',()=>{
  update_filters()
})

document.getElementById('Filter-Source-Btn-Natural').addEventListener('click',()=>{
  update_filters_natural()
})





function update_filters(){
  const gradingHeader = document.querySelector('.diamond-header-percision')
  if (gradingHeader) gradingHeader.textContent = diamond_shape === 'ROUND' ? 'Cut' : 'Symmetry'

  if(diamond_shape == 'ROUND'){
    d_shape_not_round = false
     //update Cut Filter for Non Round Shapes
     let cut_info_text = document.getElementById('Filter-Info-Cut-Text')
     cut_info_text.innerText = 'The cut of a diamond is often considered the most crucial factor affecting its beauty. It determines how effectively the stone interacts with light, creating brilliance and sparkle. Lucce only uses diamonds with Excellent (EX) to Ideal (ID) cut to maximize your diamond’s enchanting sparkle. IGI Ideal is equivalent to GIA Excellent.'
     let cut_lbl = document.getElementById('Cut-EX')
     cut_lbl.style.paddingLeft = ''
     cut_lbl.style.marginLeft = ''
 
     Array.from(document.getElementById('Slider-Cut-Values').querySelectorAll('span')).forEach((span,index)=>{
       span.innerText = round_cut_scale[index]
   })
  } else {
    d_shape_not_round = true
    //update Cut Filter for Non Round Shapes
    let cut_info_text = document.getElementById('Filter-Info-Cut-Text')
    cut_info_text.innerText = 'The cut of a diamond is often considered the most crucial factor affecting its beauty. It determines how effectively the stone interacts with light, creating brilliance and sparkle. Lucce only uses fancy shape diamonds with Excellent (EX) cut.'
    let cut_lbl = document.getElementById('Cut-EX')
    cut_lbl.style.paddingLeft = '0px'
    cut_lbl.style.marginLeft = '-10px'

    Array.from(document.getElementById('Slider-Cut-Values').querySelectorAll('span')).forEach((span,index)=>{
      span.innerText = not_round_cut_scale[index]
  })
  }

  if(d_shape_not_round){
    filter_values_default['CUT_MIN'] = 4
  }else{
    filter_values_default['CUT_MIN'] = 3
  }

  if(d_shape_not_round){
    updateSlider('Cut',4,4)
  } else{
    updateSlider('Cut',3,4)
  }

  $( "#Slider-Range-Cut" ).slider( "option", "values", [ filter_values_default['CUT_MIN'], filter_values_default['CUT_MAX'] ]);


}

function update_filters_natural(){
  if(diamond_shape == 'ROUND'){
    d_shape_not_round = false
  } else {
    d_shape_not_round = true
  }

  let cut_lbl = document.getElementById('Cut-EX')
  cut_lbl.style.paddingLeft = '0px'
  cut_lbl.style.marginLeft = '-10px'

  $( "#Slider-Range-Cut" ).slider( "option", "values", [ filter_values_default['CUT_MIN'], filter_values_default['CUT_MAX'] ]);
}


async function get_previous_items(){
  return $.ajax({
      type:'GET',
      url:'\\cart.js',
     });

}

function parse_previous_items(data){
  data = JSON.parse(data)
  //already in cart
  let existing_products = ''
  let items = data['items']

  
  items.forEach(item=>{
      existing_products = existing_products + ',' + item['variant_id'] + ':' + item['quantity']
  })

  return existing_products
}
